/**
 * Extract the page title from the browser tab.
 * @returns page title
 */
export const currentPageTitle = (): string =>
  document.title.split('|')[0].trim();

/**
 * List of soft error codes that shouldn't be logged as failed in the API metrics.
 * In the future this will be managed in https://verbatim.spectrumtoolbox.com/
 */
export const softErrorCodes: string[] = [
  '2076', // PINXT - Access token expired
];
